import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import '../styles/lines.css';

const MVBTimelie = () => {
    return (
        <motion.div
            className="p-8 bg-gray-100 min-h-screen flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <VerticalTimeline layout="1-column">
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#96226E" }}
                    icon={<FaCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                 
                    <h4 className="text-3xl font-bold mt-2 font-poppins">Product Scope</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                    The Product Scope is an intensive, 15-day, structured process. It all starts with an immersive focus session where you’ll sit down with product experts and ex-startup founders to dive into the product vision from a business standpoint.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>User Stories</li>
                        <li>Sitemap</li>
                        <li>UX Personas</li>
                        <li>Key BPMN</li>
                        <li>Tech Spike</li>
                        <li>Stakeholder Analysis</li>
                    </ul>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#96226E" }}
                    icon={<FaCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h4 className="text-3xl font-bold mt-2 font-poppins">Key Screens</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                    We start by creating the most important screens for your product. This allows you to see exactly how your product will look and then approve the design.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>UI Concept</li>
                        <li>Design System</li>
                    </ul>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#96226E" }}
                    icon={<FaCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h4 className="text-3xl font-bold mt-2 font-poppins">All Screens</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                    Once you are happy and approve the Key Screens, we extend the design to the remaining screens necessary for the MVP.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Full Product UX/UI</li>
                    </ul>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#96226E" }}
                    icon={<FaCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h4 className="text-3xl font-bold mt-2 font-poppins">Development</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                    After your product is fully designed and approved we start the implementation phase. During this phase, we progressively deliver the modules of the app, so you can test them during the process.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Progressive Module Delivery</li>
                        <li>Ongoing Testing and Feedback</li>
                        <li>Codebase Documentation</li>
                        <li>Regular Progress Updates</li>
                    </ul>
                </VerticalTimelineElement>

                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#96226E" }}
                    icon={<FaCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h4 className="text-3xl font-bold mt-2 font-poppins">Test and Launch</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                    Once your product is fully developed we enter a testing phase during which we’re in constant contact to fix major bugs and make sure your product is ready to go to market.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Bug Reports & Fixes</li>
                        <li>Final Quality Assurance (QA)</li>
                        <li>User Acceptance Testing (UAT)</li>
                        <li>Launch Readiness Sign-Off</li>
                    </ul>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </motion.div>
    );
};

export default MVBTimelie;